(function (module) {
    "use strict";

    module.service('chamferingForecasInitService', ['imsDataCommonService', 'synchronousEventsBus', '$q', 'volumeToValueService',
        function(
            this: $TSFixMe,
            imsDataCommonService: $TSFixMe,
            synchronousEventsBus: $TSFixMe,
            $q: ng.IQService,
            volumeToValueService: $TSFixMe
        ) {
            var self = this;

            self.initialize = (forecast: $TSFixMe, response: $TSFixMe) => {

                
                var historicalDataLength = moment.utc(forecast.parameters.historicalDataEnd).diff(moment.utc(forecast.parameters.historicalDataStart), 'months') + 1;
                
                var forecastLength = moment.utc(forecast.parameters.forecastEndDate).diff(moment.utc(forecast.parameters.forecastStartDate), 'months') + 1;

                forecast.imsDataTimestamp = response.data.imsImportDate;
                forecast.imtDataToMonth = response.data.imsDataTo;

                const marketForecastValue = response.data.marketAveragePrice?.length ? {
                    statisticalForecast: volumeToValueService.calculateValueInMonths(
                        
                        _.last(response.data.marketAveragePrice).averagePrice,
                        response.data.marketForecast.volume, 
                        response.data.priceChangeInYears, 
                        forecast.parameters.forecastStartDate, 
                        forecast.parameters.forecastEndDate, 
                        forecast.parameters.forecastType.typeId),
                    pmForecast: volumeToValueService.calculateValueInMonths(
                        
                        _.last(response.data.marketAveragePrice).averagePrice,
                        response.data.marketForecast.volume, 
                        response.data.priceChangeInYears, 
                        forecast.parameters.forecastStartDate, 
                        forecast.parameters.forecastEndDate, 
                        forecast.parameters.forecastType.typeId)
                } : null;

                forecast.market.forecast = {
                    historicalData: response.data.market.volume,
                    historicalValueData:  response.data.market.value,
                    statisticalForecast: response.data.marketForecast.volume,
                    pmForecast: response.data.marketForecast.volume,
                    yearlyAveragePrice: response.data.marketAveragePrice,
                    priceChangeInYears: response.data.priceChangeInYears,
                    value: marketForecastValue
                };

                for (const brand of forecast.market.brands) {
                    
                    var brandGroupServerData = _.find(response.data.brandGroups, (b: $TSFixMe) => imsDataCommonService.arraysAreEqual(brand.externalIds, b.brandExternalIds));

                    if (angular.isUndefinedOrNull(brandGroupServerData))
                        continue;

                    brand.forecast = {
                        
                        historicalVolumeData: _.times(historicalDataLength, _.constant(null)),
                        
                        historicalValueData: _.times(historicalDataLength, _.constant(null)),
                        
                        historicalMksh: _.times(historicalDataLength, _.constant(null)),
                        volume: {
                            pmForecast: new Array(forecastLength),
                        },
                        value: {
                            pmForecast: new Array(forecastLength),
                        }
                    }

                    for (const sku of brand.skus) {
                        
                        var serverSku = _.find(brandGroupServerData.skus, (s: $TSFixMe) => s.oracleCode == sku.oracleIndex);

                        if (angular.isUndefinedOrNull(serverSku))
                            continue;


                        sku.forecast = {
                            
                            historicalPrice: _.times(historicalDataLength, _.constant(null)),
                            
                            historicalBrandShr: _.times(historicalDataLength, _.constant(null)),
                            price: createMonthlyArrayFromYearlyData(serverSku.yearlyForecast, 'price', forecast.parameters.forecastStartDate, forecastLength),
                            correction: [],
                            volume: {
                                statisticalForecast: []
                            },
                            value: {},
                            exFactory: {
                                sales: null,
                                salesTo: null,
                                salesFrom: null,
                                itemsInStock: serverSku.itemsInStock,
                                originalItemsInStock: null,
                                itemsInStockDate: null,
                                rotation: serverSku.rotation,
                                originalRotation: serverSku.rotation,
                                originalLaunchDate: serverSku.launchDate,
                                launchDate: serverSku.launchDate,
                                
                                historicalValueData: _.times(historicalDataLength, _.constant(null)),
                                
                                historicalVolumeData: _.times(historicalDataLength, _.constant(null)),
                                algorithmType: 'ExFactorySlidingWindowCalculator'
                            },
                            yearlyData: serverSku.yearlyForecast
                        };
                    }
                }
                return $q.when();
            }

            function createMonthlyArrayFromYearlyData(yearlyData: $TSFixMe, property: $TSFixMe, forecastStartDate: $TSFixMe, forecastLength: $TSFixMe) {
                let array = new Array(forecastLength);
                
                var month = moment.utc(forecastStartDate);
                for (let i = 0; i < forecastLength; i++) {
                    
                    const yearData = yearlyData[_.sortedIndex(yearlyData, {
                        year: month.year()
                    }, "year")];
                    if (yearData) {

                        array[i] = angular._get(yearData, property);
                    } else {
                        array[i] = null;
                    }

                    month.add(1, 'months');
                }
                return array;
            }


        }
    ]);


})(angular.module('topline.services'));